import axios from "axios"
import loginService from "./loginService"
import { BASE_SERVER_URL } from "../constants"

const deleteUser = (username) => {
    const URL = `${BASE_SERVER_URL}/user/${username}`
    return loginService.getCredentials()
        .then(creds => {
            const config = {
                headers: {
                    Authorization: creds.accessToken
                }
            }
            return axios.delete(URL, config)
                .then(ret => {
                    return ret
                }).catch(err => err)
        })
}


export default { deleteUser }